export default __webpack_public_path__ + "static/media/calciobet_receipt.155d088d.jpg";